/**
 * Calculates a date string based on the provided date.
 * Since the toJSON() method is affected by the timezone, we need to ensure that the exact date the user has selected is sent to the endpoint.
 * This function should return a string in the format 'YYYY-MM-DD'.
 * If the date is null, it should return null.
 * If the date is a string, it is actually of DateTimeOffset type which is generated for the frontend as string (2025-08-05T12:00:00+02:00)
 * @param val
 */
export function getDateString(val: Date | string | null) {
	if (!val) {
		return null;
	}
	const dateObj = new Date(typeof val === 'string' ? val.split('T')[0].replace(/-/g, '/') : val);
	const year = dateObj.getFullYear();
	const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Months are zero-based
	const day = String(dateObj.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
}

export function formatDate(dateString: Date | string | null, locale: string) {
	if (!dateString) {
		return '';
	}
	let val = dateString;
	if (typeof dateString === 'string') {
		val = dateString.split('T')[0].replace(/-/g, '/');
	}
	const date = new Date(val);

	return Intl.DateTimeFormat(locale, {
		day: 'numeric',
		month: 'short',
		year: 'numeric',
	}).format(date);
}
